<template>
    <div class="video-container">
        <!-- Navbar -->
        <nav class="nav-bar">
            <div class="nav-left">
                <img src="@/assets/images/logot.svg" class="logo" alt="decast" @click="$router.push('/')">
                <h1 class="recording-title">{{ displayTitle }}</h1>
            </div>
            <div class="nav-right">
                <button class="share-btn" @click="shareRecording">
                    <img src="@/assets/images/share.svg" /> Share
                </button>
            </div>
        </nav>

        <!-- Main Content -->
        <div v-if="videoUrl" class="main-content">
            <div class="content-grid">
                <!-- Video Player -->
                <!-- <div class="video-section">
                    <video ref="videoPlayer" class="video-player" controls>
                        <source :src="videoUrl" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div> -->

                <!-- Summary Panel -->
                <div class="summary-panel panel">
                    <div class="panel-header">
                        <h2 class="panel-title">Summary & Key Points</h2>
                        <div class="download-options" v-if="summary">
                            <img @click="downloadSummary('txt')" class="download-btn" src="@/assets/images/down.png"
                                title="Download as TXT" />
                            <img @click="downloadSummary('json')" class="download-btn" src="@/assets/images/json.png"
                                title="Download as JSON" />
                        </div>
                    </div>
                    <div class="search-bar">
                        <input v-model="searchQuery2" type="text" placeholder="Search summary..."
                            @input="debouncedSearch2" ref="summarySearchInput" />
                        <div class="search-controls">
                            <span class="match-count" v-if="searchQuery2">{{ matchCount2 }} matches</span>
                            <div class="navigation-arrows" v-if="searchQuery2 && matchCount2 > 0">
                                <button @click="navigateSummaryMatch(-1)" class="arrow-btn"
                                    title="Previous match">↑</button>
                                <button @click="navigateSummaryMatch(1)" class="arrow-btn" title="Next match">↓</button>
                            </div>
                        </div>
                    </div>
                    <div class="panel-content" v-if="loading === 'checking'">
                        <div class="spinner">
                            <img src="@/assets/images/logot.svg" class="spinner-logo" alt="decast" />
                            <p>Checking existing summary...</p>
                        </div>
                    </div>
                    <div class="panel-content" v-if="loading === 'starting'">
                        <div class="spinner">
                            <img src="@/assets/images/logot.svg" class="spinner-logo" alt="decast" />
                            <p>Starting summary process...</p>
                        </div>
                    </div>
                    <div class="panel-content" v-if="loading === 'processing'">
                        <div class="spinner">
                            <img src="@/assets/images/logot.svg" class="spinner-logo" alt="decast" />
                            <p>Processing summary...</p>
                        </div>
                    </div>
                    <div class="panel-content formatted-text" ref="summaryContainer" v-else v-html="highlightedSummary">
                    </div>
                </div>

                <!-- Transcription Panel -->
                <div class="transcription-panel panel">
                    <div class="panel-header">
                        <h2 class="panel-title">Transcription</h2>
                        <div class="download-options" v-if="speakers">
                            <img @click="downloadTranScript('txt')" class="download-btn" src="@/assets/images/down.png"
                                title="Download as TXT" />
                            <img @click="downloadTranScript('json')" class="download-btn" src="@/assets/images/json.png"
                                title="Download as JSON" />
                        </div>
                    </div>
                    <div class="search-bar">
                        <input v-model="searchQuery" type="text" placeholder="Search transcription..."
                            @input="debouncedSearch" ref="searchInput" />
                        <div class="search-controls">
                            <span class="match-count" v-if="searchQuery">{{ matchCount }} matches</span>
                            <div class="navigation-arrows" v-if="searchQuery && matchCount > 0">
                                <button @click="navigateTranscriptMatch(-1)" class="arrow-btn"
                                    title="Previous match">↑</button>
                                <button @click="navigateTranscriptMatch(1)" class="arrow-btn"
                                    title="Next match">↓</button>
                            </div>
                        </div>
                    </div>

                    <div class="panel-content" v-if="loading === 'checking'">
                        <div class="spinner">
                            <img src="@/assets/images/logot.svg" class="spinner-logo" alt="decast" />
                            <p>Checking existing transcription...</p>
                        </div>
                    </div>
                    <div class="panel-content" v-if="loading === 'starting'">
                        <div class="spinner">
                            <img src="@/assets/images/logot.svg" class="spinner-logo" alt="decast" />
                            <p>Starting transcription process...</p>
                        </div>
                    </div>
                    <div class="panel-content" v-if="loading === 'processing'">
                        <div class="spinner">
                            <img src="@/assets/images/logot.svg" class="spinner-logo" alt="decast" />
                            <p>Processing transcription, this is a one time process...</p>
                        </div>
                    </div>
                    <div class="panel-content transcript-content" ref="transcriptionContainer" v-else
                        v-html="highlightedTranscript"></div>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div v-else class="loading-state">
            <div class="spinner">
                <img src="@/assets/images/logot.svg" class="spinner-logo" alt="decast" />
                <p>Loading recording...</p>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/http/api/api.js'
import debounce from 'lodash/debounce';

export default {
    name: "PlayRecording",
    data() {
        return {
            videoUrl: null,
            recording: null,
            speakers: null,
            summary: null,
            recording_id: "",
            public_meeting_id: "",
            loading: false,
            taskId: null,
            pollingInterval: null,
            searchQuery: "", 
            searchQuery2: "", 
            matchCount: 0, 
            matchCount2: 0, 
            currentMatchIndex: -1, 
            currentMatchIndex2: -1 
        };
    },
    created() {
        this.initializeRecording();
        this.debouncedSearch = debounce(this.handleSearch, 300);
        this.debouncedSearch2 = debounce(this.handleSearch2, 300);
        const recordingId = this.$route.params.recordingId;
    },
    computed: {
        formattedSummary() {
            return this.formatSummary(this.summary);
        },
        formattedTranscript() {
            return this.formatParagraphs(this.highlightSpeakers(this.speakers));
        },
        highlightedTranscript() {
            return this.searchInTranscript(this.formattedTranscript, this.searchQuery);
        },
        highlightedSummary() {
            return this.searchInSummary(this.formattedSummary, this.searchQuery2);
        },
        displayTitle() {
            return this.recording?.Name || "Recording Transcription";
        }
    },
    mounted() {
         console.log('RecordingCard mounted:', this.recording);
        this.$nextTick(() => {
            this.$el.addEventListener('click', (e) => {
                if (e.target.classList.contains('timestamp')) {
                    const timeText = e.target.innerText; 
                    const [hours, min, sec] = timeText.split(':').map(Number);
                    const seconds = hours * 3600 + min * 60 + sec;
                    this.seekTo(seconds);
                }
            });
        });
    },
    methods: {
        async initializeRecording() {
            this.recording = this.$store.state.cast.recording;

            if (this.recording) {
                this.recording_id = this.recording["Record ID"]? this.recording["Record ID"] : this.recording.recordId;
                this.public_meeting_id = this.recording.pub_id ? this.recording.pub_id : this.recording.castId;
                await this.startTranscription();
            } else {
                console.error("No recording found in store.");
                const recordingIdFromPath = this.$route.params.recordingId;
                if (recordingIdFromPath) {
                    this.recording_id = recordingIdFromPath;
                    await this.startTranscription();
                } else {
                    this.$router.push({ name: "Welcome to Dashbord" });
                }
            }
            this.videoUrl = `${this.$globals.roomDomain}/playback/video/${this.recording_id}/video-0.m4v`;
            await this.startTranscription();
        },
        async startTranscription() {
            if (!this.recording_id) {
                console.error("No recording ID provided");
                return;
            }

            this.loading = "checking"; 
            try {
                const checkResponse = await api.get(`${this.$globals.transcriptionBaseUrl}/api/audio/transcription/${this.recording_id}/`);
                console.log(checkResponse, 'check');
                if (checkResponse.data.transcription) {
                    this.transcript = checkResponse.data.transcription;
                    this.summary = checkResponse.data.summary;
                    this.speakers = checkResponse.data.speaker_identified_text;
                    this.loading = false; 
                    return;
                }
            } catch (error) {
                console.log("No existing transcription found, proceeding with new request.");
            }

            this.loading = "starting"; 
            try {
                const response = await api.post(`${this.$globals.transcriptionBaseUrl}/api/audio/upload/`, {
                    recordingId: this.recording_id,
                    public_meeting_id: this.public_meeting_id,
                });

                this.taskId = response.data.task_id;
                console.log("Task started with ID:", this.taskId);
                this.pollTaskStatus();
            } catch (error) {
                console.error("Error starting transcription:", error);
                this.loading = false;
            }
        },
        async pollTaskStatus() {
            if (!this.taskId) {
                console.error("No task ID available");
                this.loading = false;
                return;
            }

            this.loading = "processing"; 
            this.pollingInterval = setInterval(async () => {
                try {
                    const response = await api.get(`${this.$globals.transcriptionBaseUrl}/api/audio/get_task_status/${this.taskId}/`);
                    const { status, result, error } = response.data;

                    if (status === "SUCCESS") {
                        this.transcript = result.transcription || "";
                        this.summary = result.summary || "";
                        this.speakers = result.speaker_identified_text || "";
                        localStorage.setItem("transcript", JSON.stringify(result));
                        clearInterval(this.pollingInterval);
                        this.loading = false;
                    } else if (status === "FAILURE") {
                        console.error("Task failed:", error);
                        clearInterval(this.pollingInterval);
                        this.loading = false;
                    }
                } catch (error) {
                    console.error("Error polling task status:", error);
                    clearInterval(this.pollingInterval);
                    this.loading = false;
                }
            }, 10000)
        },
        handleSearch() {
            this.currentMatchIndex = -1; 
            this.$nextTick(() => {
                const container = this.$refs.transcriptionContainer;
                const matches = container?.querySelectorAll('.search-match');
                this.matchCount = matches?.length || 0;
                if (matches?.length) {
                    this.currentMatchIndex = 0;
                    matches[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },
        handleSearch2() {
            this.currentMatchIndex2 = -1; 
            this.$nextTick(() => {
                const container = this.$refs.summaryContainer;
                const matches = container?.querySelectorAll('.search-match2');
                this.matchCount2 = matches?.length || 0;
                if (matches?.length) {
                    this.currentMatchIndex2 = 0;
                    matches[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },
        searchInTranscript(text, query) {
            if (!query.trim()) return text;
            const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
            return text.replace(regex, '<mark class="search-match">$1</mark>');
        },
        searchInSummary(text, query) {
            if (!query.trim()) return text;
            const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
            return text.replace(regex, '<mark class="search-match2">$1</mark>');
        },
        navigateSummaryMatch(direction) {
            const container = this.$refs.summaryContainer;
            const matches = container?.querySelectorAll('.search-match2');
            if (!matches?.length) return;

            this.currentMatchIndex2 = (this.currentMatchIndex2 + direction + matches.length) % matches.length;
            matches[this.currentMatchIndex2].scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        navigateTranscriptMatch(direction) {
            const container = this.$refs.transcriptionContainer;
            const matches = container?.querySelectorAll('.search-match');
            if (!matches?.length) return;

            this.currentMatchIndex = (this.currentMatchIndex + direction + matches.length) % matches.length;
            matches[this.currentMatchIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        toggleFullScreen() {
            const iframe = this.$el.querySelector('.video-player');
            if (iframe.requestFullscreen) {
                iframe.requestFullscreen();
            }
        },
        shareRecording() {
            navigator.share({
                title: this.recording?.Name || "Recording Player",
                url: `${this.$globals.clientDomain}/recording-play/${this.recording_id}`,
            }).catch(err => console.error('Share failed:', err));
        },
        downloadTranScript(format) {
            if (!this.transcript) return;
            let content, blob, filename;
            if (format === "txt") {
                content = this.transcript;
                blob = new Blob([content], { type: "text/plain" });
                filename = "transcription.txt";
            } else if (format === "json") {
                content = JSON.stringify({ transcription: this.transcript, summary: this.summary }, null, 2);
                blob = new Blob([content], { type: "application/json" });
                filename = "transcription.json";
            }
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        downloadSummary(format) {
            if (!this.summary) return;
            let content, blob, filename;
            if (format === "txt") {
                content = this.summary;
                blob = new Blob([content], { type: "text/plain" });
                filename = "summary.txt";
            } else if (format === "json") {
                content = JSON.stringify({ transcription: this.transcript, summary: this.summary }, null, 2);
                blob = new Blob([content], { type: "application/json" });
                filename = "summary.json";
            }
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        formatSummary(text) {
            if (!text) return '';

            //  timestamps 
            text = text.replace(/\[(\d{2}:\d{2})\]/g, '<span class="timestamp text-grey-500 font-semibold cursor-pointer">[$1]</span>');
            return text
                .split('\n')
                .filter(line => line.trim())
                .map(line => {
                    const trimmed = line.trim();

                    // Convert "### Key Points:"
                    if (trimmed.startsWith('###')) {
                        return `<h3 class="text-lg font-semibold my-4 text-green-500">${trimmed.replace(/^###\s*/, '')}</h3>`;
                    }
                    // Convert "**bold text**" inside numbered points to yellow bold
                    const formatted = trimmed.replace(/\*\*(.+?)\*\*/g, '<span class="text-yellow-500 font-bold">$1</span>');

                    return `<p class="mb-2">${formatted}</p>`;
                })
                .join('');
        },
        formatParagraphs(text) {
            if (!text) return '';

            const parts = text.split(/\[(\d{2}:\d{2}:\d{2})\]/g); 
            let html = '';
            let lastValidTimestamp = null;

            for (let i = 1; i < parts.length; i += 2) {
                const timestamp = parts[i];
                const paragraph = parts[i + 1]?.trim();

                if (timestamp && paragraph && paragraph.replace(/<[^>]+>/g, '').trim()) {
                    if (lastValidTimestamp !== timestamp || paragraph !== parts[i - 1]?.trim()) {
                        html += `
                            <div class="timestamp-paragraph flex items-start mb-3">
                                <span class="timestamp text-blue-200 font-bold cursor-pointer mr-2">${timestamp}</span>
                                <span class="paragraph-text mb-3">${paragraph}</span>
                            </div>
                        `;
                        lastValidTimestamp = timestamp;
                    }
                }
            }

            return html;
        },
        handleTimestampClick(timeText) {
            console.log("Timestamp clicked:", timeText);
            const [hours, min, sec] = timeText.split(':').map(Number);
            const seconds = hours * 3600 + min * 60 + sec;
            this.seekTo(seconds);
        },
        seekTo(seconds) {
            console.log("SeekTo called with:", seconds);
            console.log("Video player ref:", this.$refs.videoPlayer);
            const player = this.$refs.videoPlayer;
            if (player) {
                player.currentTime = seconds;
                player.play();
            } else {
                console.error("Video player not found");
            }
        },
        highlightSpeakers(text) {
            if (!text) return "";
            const speakerColors = {};
            const colors = ["text-red-500", "text-blue-500", "text-green-500", "text-cyan-300", "text-pink-400", "text-purple-500", "text-pink-500", "text-orange-500"];
            let colorIndex = 0;

            return text.replace(/<b>(.*?)<\/b>/g, (match, speaker) => {
                if (!speakerColors[speaker]) {
                    speakerColors[speaker] = colors[colorIndex % colors.length];
                    colorIndex++;
                }
                return `<span class="${speakerColors[speaker]} font-bold drop-shadow-[0_0_2px_rgba(255,255,255,0.3)]">${speaker}</span>`;
            });
        },
        formatSpeakers(text) {
            if (!text) return "";
            let lines = text.split("\n");
            let seenInitials = {};

            return lines
                .filter(line => {
                    const cleanLine = line.replace(/<[^>]+>/g, '').trim();
                    return cleanLine && !line.match(/^\s*<b>.*<\/b>\s*(:)?\s*$/) && !line.match(/^\s*\d{2}:\d{2}:\d{2}\s*$/);
                })
                .map(line => {
                    let match = line.match(/<b>(.*?)<\/b>/);
                    if (match) {
                        let name = match[1];
                        let initial = name.charAt(0).toUpperCase();
                        if (!seenInitials[initial]) {
                            seenInitials[initial] = `hsl(${Math.random() * 360}, 60%, 70%)`;
                        }
                        return `<div class='speaker-block'>
                            <div class='avatar' style='background: ${seenInitials[initial]};'>${initial}</div>
                            <div>
                                <p class='speaker-name'>${name}</p>
                                <p class='speaker-text'>${line.replace(match[0], "").trim()}</p>
                            </div>
                        </div>`;
                    }
                    return `<p class='speaker-text'>${line.trim()}</p>`;
                })
                .join("\n");
        }
    }
};
</script>

<style scoped>
* {
    font-family: 'JetBrains Mono', monospace;
    box-sizing: border-box;
}

.video-container {
    min-height: 100vh;
    background-color: #000000;
    color: #FFFFFF;
    padding: 0;
    display: flex;
    flex-direction: column;
}

.nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 2rem;
    background-color: rgba(0, 0, 0, 0.9);
    position: sticky;
    top: 0;
    z-index: 100;
    border-bottom: 1px solid #333;
}

.nav-left {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.logo {
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.logo:hover {
    transform: scale(1.1);
}

.recording-title {
    font-size: 1.25rem;
    font-weight: 500;
    color: #FFFFFF;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 40vw;
}

.share-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.6rem 1.2rem;
    background-color: transparent;
    border: 2px solid #22C55E;
    color: #22C55E;
    font-weight: 500;
    transition: all 0.3s ease;
    cursor: pointer;
}

.share-btn:hover {
    background-color: #22C55E;
    color: #000000;
    box-shadow: 0 0 10px rgba(34, 197, 94, 0.5);
}

.share-btn img {
    width: 1rem;
    height: 1rem;
}

/* Main Content Layout */
.main-content {
    flex: 1;
    padding: 1.5rem 2rem;
}

.content-grid {
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    grid-template-rows: auto 1fr;
    gap: 1.5rem;
    height: auto;
}

.video-section {
    grid-column: 1;
    grid-row: 1;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.video-player {
    width: 100%;
    height: 100%;
    max-height: 60vh;
    background-color: #000;
    outline: none;
}

.summary-panel {
    grid-column: 2;
    grid-row: 1 / span 2;
    display: flex;
    flex-direction: column;
    height: 87vh;
}

.transcription-panel {
    grid-column: 1;
    grid-row: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    height: 87vh;
}

.panel {
    background-color: #111;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 1px solid #333;
}

.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.5rem;
    background-color: #1A1A1A;
    border-bottom: 1px solid #333;
}

.panel-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #d7df23;
    margin: 0;
}

.download-options {
    display: flex;
    gap: 0.75rem;
}

.download-btn {
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
    transition: all 0.2s ease;
    opacity: 0.7;
}

.download-btn:hover {
    opacity: 1;
    transform: translateY(-2px);
}

/* Search Bar Styles */
.search-bar {
    display: flex;
    align-items: center;
    padding: 0.75rem 1.5rem;
    background-color: #1A1A1A;
    border-bottom: 1px solid #333;
    position: relative;
}

.search-bar input {
    flex: 1;
    padding: 0.6rem 1rem;
    background-color: #222;
    border: 1px solid #333;
    color: #FFFFFF;
    font-size: 0.9rem;
    outline: none;
    transition: all 0.2s ease;
}

.search-bar input:focus {
    border-color: #22C55E;
    box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.3);
}

.search-bar input::placeholder {
    color: #666;
}

.search-controls {
    display: flex;
    align-items: center;
    margin-left: 1rem;
}

.match-count {
    font-size: 0.8rem;
    color: #999;
    margin-right: 0.5rem;
}

.navigation-arrows {
    display: flex;
    gap: 0.25rem;
}

.arrow-btn {
    background-color: #22C55E;
    color: #000;
    border: none;
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
}

.arrow-btn:hover {
    background-color: #2ED158;
}

/* Panel Content Styles */
.panel-content {
    flex: 1;
    padding: 1.5rem;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #22C55E #222;
}

.panel-content::-webkit-scrollbar {
    width: 8px;
}

.panel-content::-webkit-scrollbar-track {
    background: #222;
}

.panel-content::-webkit-scrollbar-thumb {
    background-color: #22C55E;
}

.transcript-content {
    line-height: 1.6;
    font-size: 0.95rem;
}

.formatted-text {
    line-height: 1.6;
}

.formatted-text p {
    margin-bottom: 1rem;
}

.speaker-block {
    margin-bottom: 1.25rem;
}

.speaker-name {
    font-weight: 600;
    color: #d7df23;
    margin-bottom: 0.25rem;
    display: inline-block;
}

.speaker-text {
    color: #EEE;
}

.timestamp {
    color: #22C55E;
    font-size: 0.85rem;
    margin-right: 0.5rem;
}

.search-match {
    background-color: #d7df23;
    color: #000;
    padding: 0.1rem 0.2rem;
    font-weight: 500;
}

.focused-match,
.focused-match2 {
    background-color: #d7df23;
    color: #000;
    padding: 0.1rem 0.2rem;
    font-weight: 700;
    box-shadow: 0 0 0 2px #d7df23;
}

.loading-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70vh;
}

.spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    text-align: center;
    animation: blinkOpacity 1.5s infinite ease-in-out;
}

.spinner-logo {
    width: 4rem;
    height: 4rem;
    opacity: 0.8;
}

.spinner p {
    color: #22C55E;
    font-size: 1.1rem;
    margin: 0;
}

@keyframes blinkOpacity {

    0%,
    100% {
        opacity: 0.8;
    }

    50% {
        opacity: 0.4;
    }
}

/* Responsive Adjustments */
@media (max-width: 1200px) {
    .content-grid {
        grid-template-columns: 1.5fr 1fr;
    }
}

@media (max-width: 992px) {
    .content-grid {
        display: flex;
        flex-direction: column;
        height: auto;
    }

    .video-section {
        height: 50vh;
    }

    .panel {
        height: 400px;
    }
}

@media (max-width: 768px) {
    .nav-bar {
        padding: 1rem;
    }

    .main-content {
        padding: 1rem;
    }

    .recording-title {
        font-size: 1rem;
        max-width: 50vw;
    }
}
</style>